import React from 'react'
import Auth from '../auth/Auth'
import LandingPageHeader from '../header/LandingPageHeader'
import LandingPageFooter from '../footer/LandingPageFooter'

export default function PrivateLayout() {

    return (
        <>
            <LandingPageHeader />
            <Auth />
            <LandingPageFooter />
        </>
    )
}
